module.exports = __webpack_public_path__ + "static/media/no-message.8910ed64.svg";